module.exports = __webpack_public_path__ + "img/black-x.4a1dbf6a.svg";